module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('p', [_vm._v("URL for QR Code Scanner Login is "), _c('a', {
    attrs: {
      "href": "https://scanner.visity.io/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.scannerUrl))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-primary button",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#exampleModalCenter"
    }
  }, [_vm._v("\n          Add Checkpoint\n        ")])]), _vm._v(" "), (_vm.ShowLoading) ? _c('div', {
    staticClass: "loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), (_vm.ShowTable) ? _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.List), function(S, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.name))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(S.password))]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(S.checkPoint)) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(S.createdOn)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group mr-3",
      attrs: {
        "role": "group",
        "aria-label": "Second group"
      }
    }, [_c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "submit",
        "data-toggle": "modal",
        "data-target": "#EditModal"
      },
      on: {
        "click": function($event) {
          return _vm.EditModal(S);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group mr-3",
      attrs: {
        "role": "group",
        "aria-label": "Second group"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.Delete(S);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exampleModalCenter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.Add()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Mobile (for login) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "minlength": "10",
      "maxlength": "10",
      "placeholder": "10 Digit Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Password *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Checkpoint *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkpoint),
      expression: "checkpoint"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "required": ""
    },
    domProps: {
      "value": (_vm.checkpoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkpoint = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "EditModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.Edit()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Person Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.name),
      expression: "EditInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Mobile *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.mobile),
      expression: "EditInfo.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "minlength": "10",
      "maxlength": "10",
      "placeholder": "10 Digit Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Password *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.password),
      expression: "EditInfo.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Checkpoint *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EditInfo.checkPoint),
      expression: "EditInfo.checkPoint"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "exampleFormControlInput1",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.EditInfo.checkPoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.EditInfo, "checkPoint", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Mobile (for login)")]), _vm._v(" "), _c('th', [_vm._v("Password")]), _vm._v(" "), _c('th', [_vm._v("Checkpoint")]), _vm._v(" "), _c('th', [_vm._v("Created On")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Add Checkpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Edit Checkpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b860d8a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Checkpoints.vue
// module id = 1492
// module chunks = 1